var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircle = function SvgCheckCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    fillRule: "evenodd",
    d: "M10.5 2.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15Zm3.617 6.43a.833.833 0 0 0-1.162-1.194L9.258 11.33 7.756 9.827a.833.833 0 0 0-1.179 1.179l2.084 2.083a.833.833 0 0 0 1.17.008l4.286-4.166Z",
    clipRule: "evenodd"
  })));
};
export default SvgCheckCircle;